import React, { HTMLAttributes } from "react";

import cn from "classnames";
import { ErrorMessage } from "src/components";

interface Props extends HTMLAttributes<HTMLDivElement> {
  isLocked?: boolean;
  isEmpty?: boolean;
  isNotLoaded?: boolean;
  customErrorMessage?: string;
}

const CardContent: React.FC<Props> = ({
  isLocked,
  isEmpty = false,
  isNotLoaded = false,
  className,
  children,
  customErrorMessage,
}) => {
  const errorMessage =
    customErrorMessage ??
    (isNotLoaded
      ? "Sajnos még nem sikerült betölteni az adatokat"
      : "Nincs megjelenítendő adat");
  return (
    <div
      className={isEmpty ? "flex flex-col gap-1 h-full justify-between" : ""}
    >
      {isEmpty && <ErrorMessage className="py-4">{errorMessage}</ErrorMessage>}
      <div
        className={cn(
          "flex",
          { "p-3": isLocked },
          `bg-contrast${isLocked ? "/60" : ""}`,
          "rounded-[10px]",
          "self-stretch",
          "flex-col",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default CardContent;
